import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCamera2Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.7929 3C15.141 3 15.4766 3.121 15.7435 3.3397L15.8536 3.43934L17.4142 5H20C21.0544 5 21.9182 5.81588 21.9945 6.85074L22 7V19C22 20.0544 21.1841 20.9182 20.1493 20.9945L20 21H4C2.94564 21 2.08183 20.1841 2.00549 19.1493L2 19V7C2 5.94564 2.81588 5.08183 3.85074 5.00549L4 5H6.58579L8.14645 3.43934C8.39259 3.19319 8.71546 3.04143 9.05885 3.00734L9.20711 3H14.7929ZM14.5858 5H9.41421L7.85355 6.56066C7.60741 6.8068 7.28454 6.95856 6.94115 6.99266L6.79289 7H4V19H20V7H17.2071C16.859 7 16.5234 6.87901 16.2565 6.6603L16.1464 6.56066L14.5858 5ZM12 7.5C14.7614 7.5 17 9.73858 17 12.5C17 15.2614 14.7614 17.5 12 17.5C9.23858 17.5 7 15.2614 7 12.5C7 9.73858 9.23858 7.5 12 7.5ZM12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5Z",
		fill: "currentColor"
	})
});
export default SvgCamera2Line;
